import { render, staticRenderFns } from "./TableTd.vue?vue&type=template&id=2061ed65"
import script from "./TableTd.vue?vue&type=script&lang=js"
export * from "./TableTd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports